import type { MathRun } from '../../../Shared/Pdf/mathRuns.ts';

/**
 * English place-value prompts (ADR 0051 part 3). `placeClauses` is a full,
 * self-contained clause per column ("in the ones place") rather than a bare
 * noun composed with a generic "the X place" template - see the Spanish and
 * French modules for why: those languages' equivalent nouns do not share one
 * gender, so a generic wrapper would get the article wrong for some of them.
 * Writing the whole clause per language avoids that by construction.
 */
export const placeClauses: string[] = [
    'in the ones place',
    'in the tens place',
    'in the hundreds place',
    'in the thousands place',
    'in the ten thousands place',
];

export const placeValuePrompts = {
    digitValue: (value: string, digit: number, placeClause: string) =>
        `In ${value}, the ${digit} is ${placeClause}. Its value is`,
    // ADR 0130 §5. Every prompt is MathText runs, even one with no exponent, so
    // the two directions look alike on the page. The exponent is an ASCII "-" (ADR 0070).
    toScientific: (standard: string): MathRun[] => [{ text: `Write ${standard} in scientific notation.` }],
    toStandard: (coefficient: string, exponent: number): MathRun[] => [
        { text: `Write ${coefficient} × 10` },
        { sup: String(exponent) },
        { text: ' in standard form.' },
    ],
};
